import React, { useState } from "react";
const NewsFeed = ({ news }) => {
  const [maxShow, setMaxShow] = useState(4);
  return (
    <div className="second_box lite_dark">
      <div className="container">
        <div className="posted_section">
          <div className="heading">
            <h2 className="title">News</h2>
          </div>
          <div className="wrap">
            {news.slice(0, maxShow).map((item) => (
              <div className="item" key={`news-${item.id}`}>
                <div className="date">{item.created_at}</div>
                <div className="content">
                  <p dangerouslySetInnerHTML={{ __html: item.message }} />
                </div>
              </div>
            ))}
          </div>
          {maxShow !== 10 ? (
            <div className="bottom">
              <div className="btn_more" onClick={() => setMaxShow(10)}>
                <i className="icon-arrow-down"></i>
                <span>show more</span>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default NewsFeed;
